import React, { useEffect, useState } from 'react';
import { fetchInventoryLimitAlerts } from '../services/api';

/**
 * Inventory Limit Alerts: the days a product hit its inventory limit, the admin portal list on the
 * SQL01 copy (Azure exit WS8).
 */

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const monthEnds = () => {
  const d = new Date();
  return [iso(new Date(d.getFullYear(), d.getMonth(), 1)), iso(new Date(d.getFullYear(), d.getMonth() + 1, 0))];
};

export default function InventoryLimitAlerts() {
  const [from, setFrom] = useState(monthEnds()[0]);
  const [to, setTo] = useState(monthEnds()[1]);
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let live = true;
    setRows(null);
    setError(null);
    fetchInventoryLimitAlerts(from, to)
      .then((r) => { if (live) setRows(r); })
      .catch((e) => { if (live) setError(e.message); });
    return () => { live = false; };
  }, [from, to]);

  return (
    <div>
      <div className="page-header">
        <h2 style={{ fontSize: 16, fontWeight: 700, color: 'var(--navy)', margin: 0 }}>Inventory Limit Alerts</h2>
      </div>
      <div className="port-filters">
        <input type="date" className="form-input" style={{ width: 'auto' }} value={from} onChange={(e) => setFrom(e.target.value)} />
        <input type="date" className="form-input" style={{ width: 'auto' }} value={to} onChange={(e) => setTo(e.target.value)} />
      </div>
      <div className="card">
        <div className="card-header">Limit hits{rows ? ` (${rows.length})` : ''}</div>
        {error && <div style={{ padding: 16, fontSize: 12, color: 'var(--red)' }}>Error: {error}</div>}
        {!rows && !error && <div style={{ padding: 16, fontSize: 12, color: 'var(--gray-500)' }}>Loading...</div>}
        {rows && rows.length === 0 && <div style={{ padding: 16, fontSize: 12, color: 'var(--gray-500)' }}>No limit hits in this range.</div>}
        {rows && rows.length > 0 && (
          <div className="port-scroll">
            <table className="trans-table">
              <thead><tr><th>Date</th><th>Hits</th><th>Product</th></tr></thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id}><td>{r.hitDate}</td><td>{r.hitCount}</td><td>{r.product}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}